module.exports = __webpack_public_path__ + "img/UtilityTechBackgroundC04_ua.5d65400b.webp";